import { XKTLoaderPlugin } from "@xeokit/xeokit-sdk";
import { fetchModel } from "./fetchModel";

const ifcLoadModel = (viewer) => {
    console.log(`🔄 Attempting to load ifc model`);

    // ✅ Prevent duplicate loading
    if (viewer.scene.models["myIfcModel"]) {
      console.warn("⚠️ Ifc Model already loaded. Skipping load.");
      return Promise.resolve(viewer.scene.models["myIfcModel"]);
    }

    return new Promise((resolve, reject) => {
        const modelUrl = fetchModel("xkt/OurDesignIFC.xkt");
        const xktLoader = new XKTLoaderPlugin(viewer);

        const model = xktLoader.load({
            id: "myIfcModel",
            src: modelUrl,
            edges: true,
            saoEnabled: true,
            dtxEnabled: true,
            objectDefaults: {
            // This model has opaque windows / spaces; make them transparent
                IfcPlate: {
                    opacity: 0.75, // These are used as windows in this model - make transparent
                    color: [0.2, 0.2, 0.2],
                    receiveShadow: true, // Darker shade (closer to black)
                },
                IfcSlab: {
                    color: [0.8, 0.8, 0.8], // Neutral gray color for the ground
                    shininess: 50, // Reflectiveness for lighting
                    receiveShadow: true, // Enable receiving shadows
                },
            },
        });
        
        model.on("loaded", () => {
            console.log(`✅ Model ${model.id} loaded successfully!`);
            model.visible= true;
            resolve(model);
        });
        model.on("error", (error) => {
            console.error(`❌ Error loading city model:`, error);
            reject(error);
          });
    });
};

export default ifcLoadModel;